import { render, staticRenderFns } from "./WarehouseCards.vue?vue&type=template&id=8bae21fa"
import script from "./WarehouseCards.vue?vue&type=script&lang=js"
export * from "./WarehouseCards.vue?vue&type=script&lang=js"
import style0 from "./WarehouseCards.vue?vue&type=style&index=0&id=8bae21fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports